export default "__VITE_ASSET__P9_DfwPi__"